export default __webpack_public_path__ + "static/media/Auth_bg_dots.dac5e1de.svg";